import request from '../utils/fetch';

//公共材质创建
export async function isDownloadable(ids: string[]): Promise<any> {
  return request(`/boss/api/v1/component/public/downloadable`, {
    tokenFree: false,
    method: 'POST',
    data: ids,
  });
}
